import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../../hook/useSettingsContext";
import SettingsForm from "../../SettingsForm";
import FieldWrapper from "../../../../components/UI/common/FieldWrapper";
import Input from "../../../../components/UI/Input";
import Textarea from "../../../../components/UI/Textarea";

export default function MessagesSettings() {
    const { settings, getSection, getOption, handleToggle, handleInputChange } =
        useSettingsContext();

    const sectionID = "messages";
    const section = getSection(sectionID);

    //console.log(settings);

    return (
        <SettingsForm
            title={__(
                "Messages Settings",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            subtitle={__(
                "Configure the error messages for quantity buttons. You can use patterns along with the message.",
                "wpbean-quantity-controls-for-woocommerce",
            )}
        >
            <FieldWrapper
                label={__(
                    "Minimum Error Message",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Available patterns %title%, %min%, %max%, %step%, %inputed%.",
                )}
                width="100"
                containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
            >
                <Textarea
                    name="minMessage"
                    value={getOption("minMessage", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                />
            </FieldWrapper>
            <FieldWrapper
                label={__(
                    "Maximum Error Message",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Available patterns %title%, %min%, %max%, %step%, %inputed%.",
                )}
                width="100"
                containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
            >
                <Textarea
                    name="maxMessage"
                    value={getOption("maxMessage", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                />
            </FieldWrapper>
            <FieldWrapper
                label={__(
                    "Step Validation Error Message",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Available patterns %nearestA%, %nearestB%, %title%, %min%, %max%, %step%, %inputed%.",
                )}
                width="100"
                containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
            >
                <Textarea
                    name="stepMessage"
                    value={getOption("stepMessage", sectionID)}
                    onChange={(key, value) =>
                        handleInputChange(section, key, value)
                    }
                />
            </FieldWrapper>
        </SettingsForm>
    );
}
